import {BaseContainerModel} from '../../base-container.model';
import {bl_aat_claim_cycle_checking_sample_link_RowClass} from '../../../dbschema';

export class ClaimCycleCheckingSampleLinkContainerModel extends BaseContainerModel {
  bl_aat_claim_cycle_checking_sample_link: bl_aat_claim_cycle_checking_sample_link_RowClass = new bl_aat_claim_cycle_checking_sample_link_RowClass();
}
